import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: {"margin":".44rem 0"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("kbd", {
  class: "DocSearch-Commands-Key",
  style: {"background":"var(--docsearch-key-gradient)"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "15",
    height: "15",
    "aria-label": "Enter key",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.2"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M12 3.53088v3c0 1-1 2-2 2H4M7 11.53088l-3-3 3-3" })
    ])
  ])
], -1)
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_form_item, {
    label: "Поиск запчастей",
    "label-position": "top",
    style: {"margin":"0"}
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_select, {
        modelValue: _ctx.selectedItem,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItem) = $event)),
        filterable: "",
        remote: "",
        disabled: _ctx.disabled,
        placeholder: "Артикул, наименование, производитель или группа запчастей",
        "remote-method": _ctx.searchItemsAsync,
        onKeyup: _withKeys(_ctx.onSelectEnterKeyUp, ["enter"]),
        onClear: _ctx.onSelectCleared,
        onChange: _ctx.onItemSelected
      }, {
        empty: _withCtx(() => [
          _createTextVNode(" Ничего не найдено ☹️ "),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _ctx.onSearchItemsInCatalogsClick
            }, {
              default: _withCtx(() => [
                _createTextVNode("Искать в каталогах")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        footer: _withCtx(() => [
          _hoisted_2
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foundItems, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.externalName,
              value: item.id
            }, {
              default: _withCtx(() => [
                (item.id)
                  ? (_openBlock(), _createElementBlock("text", _hoisted_3, [
                      _createElementVNode("strong", null, _toDisplayString(item.partNumber.toUpperCase()), 1),
                      _createTextVNode(" " + _toDisplayString(item.externalName) + ", " + _toDisplayString(item.manufacturer?.name), 1)
                    ]))
                  : (_openBlock(), _createBlock(_component_el_text, {
                      key: 1,
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Искать артикул '" + _toDisplayString(_ctx.searchItemsQuery) + "' в каталогах ", 1)
                      ]),
                      _: 1
                    }))
              ]),
              _: 2
            }, 1032, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "disabled", "remote-method", "onKeyup", "onClear", "onChange"])), [
        [_directive_loading, _ctx.isAsyncOperationPending]
      ])
    ]),
    _: 1
  }))
}